module.exports = __webpack_public_path__ + "static/media/B_S02.98bd0873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/B_S02.png
// module id = 119
// module chunks = 0